import { FormBase } from '../interfaces/formInterface';

export class EncryptedTextField extends FormBase<string> {
  controlType = 'passwd';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}